import React from 'react';
import styled from 'styled-components';
export default function ContactMe() {
  return (
    <Container id="contact">
      <div className="container">
        <Title>Contact</Title>
        <UntitleList>
          <li><ContactType>EMAIL</ContactType><div>sirion<AtSignComponent />it.kmitl.ac.th</div></li>
          <li><ContactType>OFFICE</ContactType>room 510-5, IT Building</li>
          <li><ContactType>MAIL</ContactType>School of Information Technology. King Mongkut's Institute of Technology Ladkrabang. Chalongkrung Rd. Ladkrabang, Bangkok Thailand 10520.</li>
          <li><ContactType>TEL</ContactType>+66 (0) 2723 4900</li>
          <li><ContactType>FAX</ContactType>+66 (0) 2723 4910</li>
        </UntitleList>
      </div>
    </Container>
  )
}
const Container = styled.section`
  padding-top: 32px;
  padding-bottom: 32px;
  background-color: rgba(var(--background),0.8);
`
const Title = styled.h2`
  font-family: 'Concert One';
`
const UntitleList = styled.ul`
  font-size: 1.1em;
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  & li {
    display: grid;
    grid-template-columns: 70px auto;
    color: var(--text-color);
    gap: 4px;
    overflow-wrap: anywhere;
    margin-bottom: 8px;
  }

  @media (max-width: 575px) {
    font-size: 1rem;

    & li {
      grid-template-columns: 1fr;
      gap: 0;
      margin-bottom: 16px;
    }
  }
`
const ContactType = styled.div`
  color: var(--assent-color);
  font-weight: 600;
  text-align: right;
  padding-right: 8px;

  @media (max-width: 575px) {
    text-align: left;
    padding-right: 0;
  }
`

const AtSignComponent = ()=>{
  return (
    <svg version="1.1" viewBox='-3 0 503 500' width="16" height="16">
      <g>
        <path fill="currentColor" d="m 340.91586,143.80551 43.72904,0 -47.42807,147.55936 c -4.21403,11.94424 -6.32087,20.55387 -6.32053,25.82892 l 0,0.53073 c -3.4e-4,9.47819 5.09253,16.50099 15.27863,21.06842 l 0.53073,0 c 3.16258,1.40463 6.67934,2.10691 10.55029,2.10684 22.48332,7e-5 43.03171,-12.64633 61.64523,-37.93924 17.92648,-24.93887 26.88993,-52.51543 26.89038,-82.72974 l 0,-0.53073 c -4.5e-4,-42.15805 -17.0428,-78.87496 -51.1271,-110.15085 C 359.88243,77.233922 317.9011,60.020021 268.72034,57.907471 l -8.44345,0 c -51.64734,3.5e-4 -97.31698,17.91653 -137.00907,53.748599 l -16.34009,16.34008 C 71.084534,167.69938 53.162993,212.84901 53.163055,263.44519 l 0,0.51465 c -6.2e-5,49.54573 18.446849,91.35551 55.340795,125.42947 37.94444,35.13546 85.20091,52.70319 141.76956,52.70322 l 0.51465,0 c 27.75856,-3e-5 61.66635,-5.62364 101.72348,-16.87082 l 14.74789,35.31775 c -39.3495,14.75319 -79.04708,22.12981 -119.09287,22.12988 C 184.91822,482.66927 130.28513,463.8739 84.26712,426.28317 41.401143,391.14771 16.628351,347.75646 9.9486694,296.10928 8.8979104,279.95159 8.3725407,271.87269 8.3725586,271.87256 8.3725407,217.77033 25.061072,167.88165 58.438202,122.20636 c 4.213612,-5.62868 8.604202,-11.07537 13.171783,-16.34009 0.35374,-0.35352 0.70756,-0.70734 1.061463,-1.06146 0.353738,-0.3428 0.702198,-0.69126 1.045379,-1.04538 4.921238,-5.617936 10.191018,-11.064626 15.809357,-16.340088 L 91.633026,85.3125 C 129.57749,50.885021 175.07558,29.28053 228.12744,20.498962 c 13.00535,-2.111813 26.00557,-3.167914 39.0007,-3.168304 58.32649,3.9e-4 109.09436,17.739661 152.30378,53.217865 40.75325,33.034297 64.29303,73.262617 70.61941,120.685057 1.05024,7.37684 1.57561,14.58191 1.57611,21.61524 l 0,0.53073 c -5e-4,42.51225 -14.75374,81.1591 -44.25976,115.94064 -0.35428,0.697 -0.7081,1.22237 -1.06147,1.57611 -26.69781,31.26494 -59.3726,46.89737 -98.02444,46.89734 -33.72052,3e-5 -53.04126,-13.52556 -57.96228,-40.57681 -23.19162,25.29287 -47.95905,37.93927 -74.30237,37.93924 l -0.53073,0 c -28.80979,3e-5 -51.47038,-12.121 -67.98184,-36.36313 -11.94428,-16.85465 -17.91634,-36.70076 -17.9162,-59.53839 l 0,-0.53073 c -1.4e-4,-38.29826 13.87391,-72.20069 41.62219,-101.7074 27.06172,-29.16315 57.98349,-43.92175 92.76538,-44.27585 l 1.04538,0 c 29.16311,2.8e-4 50.41914,15.10734 63.76816,45.32123 l 0.53073,0.53073 z m -79.04678,22.66062 c -23.19159,2.4e-4 -43.5738,12.47509 -61.14667,37.42459 -15.80419,22.13006 -23.70618,47.0744 -23.70599,74.8331 l 0,0.53073 c -1.9e-4,23.53455 8.25562,41.27382 24.76745,53.21786 l 0.53074,0 c 8.07332,5.97214 16.8545,8.95817 26.34356,8.9581 l 0.53073,0 c 20.37125,7e-5 38.28743,-11.41868 53.7486,-34.25629 11.60073,-16.86534 20.21036,-40.0513 25.82892,-69.55795 l 2.63757,-20.55377 c 1.05042,-19.32055 -6.50311,-33.72533 -22.66061,-43.21439 -8.08456,-4.92108 -17.04265,-7.38174 -26.8743,-7.38198 z"/>
      </g>
    </svg>
  )
}